import type { IconData } from '@stacksjs/iconify-core'

export const iInformationUs: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M61.928 31.948c0 16.763-13.589 30.353-30.352 30.353S1.224 48.713 1.224 31.948c0-16.764 13.588-30.353 30.352-30.353c16.763 0 30.352 13.59 30.352 30.353M31.576 8.38c-13.017 0-23.569 10.552-23.569 23.569s10.551 23.57 23.569 23.57s23.569-10.554 23.569-23.57C55.146 18.933 44.593 8.38 31.576 8.38m-6.213 16.515c0-4.788 3.071-6.469 6.14-6.469c1.827 0 3.391.169 4.641 1.717c2.924 3.619-.339 7.131-4.057 8.99c-2.631 1.316-3.874 3.546-3.874 6.651v6.946h6.943v-4.094c0-6.25 4.02-4.679 6.944-8.588c3.954-5.288 3.099-11.249-2.267-15.496c-6.138-4.861-13.084-2.449-15.02-1.133c-1.609 1.093-7.309 5.153-6.213 13.887l6.747.014c0 .001.014-.817.014-2.425zm9.795 27.337v-7.126h-6.943v7.126z\"/>",
  "width": 63,
  "height": 64,
  "viewBox": "0 0 63 64"
}

export default iInformationUs
